import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {replaceItem} from '../../common/util/array';

const INITIAL_STATE = {
  'loading': false,
  'configuration': [],
};

const updateValue = (configuration, {section, step, field, value}) => {
  const parameterIndex =
    configuration.findIndex((parameter) => parameter.transport === section && parameter.status === step);

  if (parameterIndex === -1) {
    return configuration;
  }
  
  const requestedParameter = {...configuration[parameterIndex], [field]: value};
  return replaceItem(configuration, parameterIndex, requestedParameter);
};

export const providerOrderTrackingConfig = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_PROVIDER_ORDERS_TRACKING_CONFIG]: (state, action) => (INITIAL_STATE),
    [ActionTypes.UPDATE_PROVIDER_ORDER_TRACKING_CONFIG_VALUE]: (state, action) => ({
      ...state,
      'configuration': updateValue(state.configuration, action.payload),
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_TRACKING_CONFIG_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_TRACKING_CONFIG_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'configuration': action.response.data,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_TRACKING_CONFIG_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'configuration': [],
    }),
    [ActionTypes.SAVE_PROVIDER_ORDERS_TRACKING_CONFIG_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.SAVE_PROVIDER_ORDERS_TRACKING_CONFIG_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.SAVE_PROVIDER_ORDERS_TRACKING_CONFIG_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
